export const LabelCodeTypeMap = {
  Account: { identifier: 'A', name: 'account' },
  Bottle: { identifier: 'B', name: 'bottle' },
  Case: { identifier: 'C', name: 'case' },
  Invoice: { identifier: 'I', name: 'invoice' },
  Location: { identifier: 'L', name: 'location' },
  ProvenanceBottle: { identifier: 'P', name: 'provenance bottle' },
  Receipt: { identifier: 'R', name: 'inbound receipt' },
  TransitUnit: { identifier: 'T', name: 'transit unit' },
  DeepLink: { identifier: 'Z', name: 'deep link' },
  Unknown: { identifier: '?', name: 'unknown' },
} as const;

export type LabelCodeType = keyof typeof LabelCodeTypeMap;
export type LabelCodeTypeIdentifier = (typeof LabelCodeTypeMap)[keyof typeof LabelCodeTypeMap]['identifier'];

export const LabelCodeTypeReverseMap: { [key in LabelCodeTypeIdentifier]: LabelCodeType } = (
  Object.keys(LabelCodeTypeMap) as LabelCodeType[]
).reduce(
  (result, key) => {
    result[LabelCodeTypeMap[key].identifier] = key;
    return result;
  },
  {} as { [key in LabelCodeTypeIdentifier]: LabelCodeType },
);

export class LabelCode {
  constructor(
    public type: LabelCodeType,
    public identifier: string,
  ) {}

  get typeIdentifier(): LabelCodeTypeIdentifier {
    return this.type ? LabelCodeTypeMap[this.type].identifier : LabelCodeTypeMap.Unknown.identifier;
  }

  get typeName(): string {
    return this.type ? LabelCodeTypeMap[this.type].name : LabelCodeTypeMap.Unknown.name;
  }

  asUri(): string {
    return `HTTPS://ARK.WINE/${this.typeIdentifier}/${this.identifier}`.toUpperCase();
  }
}
